/**
 * Network Card Skeleton Component
 * Loading state for network cards
 */

import React from 'react';

export const NetworkCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 animate-pulse">
      {/* Header with checkbox and logo */}
      <div className="flex items-start gap-4 mb-4">
        <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="w-24 h-10 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="flex-1" />
        <div className="w-20 h-6 bg-gray-200 dark:bg-gray-700 rounded-full" />
      </div>

      {/* Platform and account name */}
      <div className="space-y-3 mb-4">
        <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-2/3" />
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
      </div>

      {/* Balance */}
      <div className="mb-4">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-2" />
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
      </div>

      {/* Last sync */}
      <div className="mb-4">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
      </div>

      {/* Action buttons */}
      <div className="flex flex-wrap gap-2 pt-4 border-t border-gray-200 dark:border-gray-700">
        <div className="h-9 bg-gray-200 dark:bg-gray-700 rounded w-24" />
        <div className="h-9 bg-gray-200 dark:bg-gray-700 rounded w-24" />
        <div className="h-9 bg-gray-200 dark:bg-gray-700 rounded w-20" />
        <div className="h-9 bg-gray-200 dark:bg-gray-700 rounded w-20" />
      </div>
    </div>
  );
};

interface NetworkCardSkeletonGridProps {
  count?: number;
}

export const NetworkCardSkeletonGrid: React.FC<NetworkCardSkeletonGridProps> = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <NetworkCardSkeleton key={index} />
      ))}
    </div>
  );
};
